<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津津旅商务信息技术股份有限公司</div>
                  <p class="p1">
                    天津津旅商务信息技术股份有限公司（以下简称“津旅商务”），是天津市国资委下属，天津市旅游（控股）集团有限公司全资二级子公司。旅游集团为打造新型现代化服务业，创新“科技+服务”的商业模式，在其前身十余年的差旅管理服务经验基础上，于2015年7月16日在天津市滨海高新区滨海科技园注册成立津旅商务，投入注册资本金3000万元，将其打造为国有体制内首家推行差旅外包服务（TMC）的现代化科技服务企业。
                  </p>
                  <p class="p2">
                    津旅商务是一家“互联网+技术研发+实体服务”的创新型现代化科技服务企业。目前主要业务范围包括企业商务的差旅管理与服务，涵盖国内机票、国际机票、酒店等业务。
                    2016年，获得国家级高新技术企业，天津实际高新技术企业、科技型中小企业等多项殊荣。2017年初，公司被天津高新区评为“2016年现代服务业十强企业。
                  </p>
                  <div class="img1">
                    <img
                      src="@/assets/images/jlsw1.jpg"
                      alt=""
                      height="450px"
                    />
                  </div>
                  <div class="img1">
                    <img
                      src="@/assets/images/jlsw2.jpg"
                      alt=""
                      height="450px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>